import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Swipeable photo carousel used inside lounge posts and chapter stories.
 * Falls back to a single image when only one photo is provided.
 */
export default function PhotoCarousel({ photos = [], testId }) {
  const clean = photos.filter(Boolean);
  const [idx, setIdx] = useState(0);
  const [touchX, setTouchX] = useState(null);

  if (!clean.length) return null;

  const go = (delta) => {
    setIdx((i) => (i + delta + clean.length) % clean.length);
  };

  const onTouchStart = (e) => setTouchX(e.touches[0].clientX);
  const onTouchEnd = (e) => {
    if (touchX === null) return;
    const dx = e.changedTouches[0].clientX - touchX;
    if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    setTouchX(null);
  };

  return (
    <div
      className="relative rounded-2xl overflow-hidden border-2 border-tb-cream-3 bg-tb-cream-2"
      data-testid={testId}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      <img
        src={clean[idx]}
        alt=""
        className="block w-full mx-auto max-h-[60vh] md:max-h-[420px] object-contain bg-tb-cream-2 select-none"
        draggable={false}
      />
      {clean.length > 1 && (
        <>
          <button
            type="button"
            onClick={() => go(-1)}
            aria-label="Previous photo"
            data-testid={testId ? `${testId}-prev` : undefined}
            className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-tb-navy/70 text-white flex items-center justify-center tb-tap hover:bg-tb-navy"
          >
            <ChevronLeft className="w-4 h-4" />
          </button>
          <button
            type="button"
            onClick={() => go(1)}
            aria-label="Next photo"
            data-testid={testId ? `${testId}-next` : undefined}
            className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-tb-navy/70 text-white flex items-center justify-center tb-tap hover:bg-tb-navy"
          >
            <ChevronRight className="w-4 h-4" />
          </button>
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5">
            {clean.map((_, i) => (
              <span
                key={i}
                className={`w-1.5 h-1.5 rounded-full ${
                  i === idx ? "bg-white" : "bg-white/50"
                }`}
              />
            ))}
          </div>
          <span className="absolute top-2 right-2 text-xs px-2 py-0.5 rounded-full bg-tb-navy/70 text-white font-ui">
            {idx + 1}/{clean.length}
          </span>
        </>
      )}
    </div>
  );
}
